export const WOMAN_BIKE_URL =
  "https://images.unsplash.com/photo-1692668696940-c6d790824ef2?q=50&w=1080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
export const INTERIOR_URL =
  "https://images.unsplash.com/photo-1686100510540-4c29a46de6e9?q=50&w=1080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
export const WOMAN_URL =
  "https://images.unsplash.com/photo-1664575602554-2087b04935a5?q=50&w=400&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
export const WORKSHOP_URL =
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=50&w=1080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
